<template>
  <div class="container">
    <div class="row mb-4">
      <div class="col">
        <VueCal
          style="height: 30rem;"
          hide-view-selector
          start-week-on-sunday
          :time="false"
          default-view="month"
          min-date="2020-01-01"
          max-date="2025-01-01"
          events-on-month-view="short"
          :events="events"
          :disable-views="['years', 'year', 'week', 'day']"
          :on-event-click="eventClick"
        >
        </VueCal>
        <h3 class="mt-4">Upcoming Dates</h3>
        <div
          class="card text-left mt-2"
          v-for="grantApplication in grantApplications"
          :key="grantApplication.Grant_Application_Id"
        >
          <div
            class="card-header"
            v-bind:class="
              $getClassForGrantApplicationStatus(
                grantApplication.Grant_Application_Status
                  .Grant_Application_Status_Id
              )
            "
          >
            <h5 class="float-left">{{ grantApplication.Grant.Title }}</h5>
            <button
              class="btn btn-sm btn-outline-primary float-right ml-2"
              v-on:click="
                setReminderDate(grantApplication.Grant_Application_Id)
              "
            >
              Add Reminder
            </button>
          </div>
          <div class="card-body pl-0 pr-0 pt-1 pb-1">
            <div
              class="pr-4 pl-4 pt-3 pb-2"
              v-if="grantApplication.Grant.Application_Deadline != '0000-00-00'"
            >
              <i
                v-on:click="
                  removeReminder(reminder.Grant_Application_Reminder_Id)
                "
                class="material-icons ml-2 pointer float-right"
                style="visibility: hidden;"
              >
                delete
              </i>
              <h5 class="float-right">
                {{ $displayDate(grantApplication.Grant.Application_Deadline) }}
              </h5>
              <h5>
                Application Due
              </h5>
            </div>
            <div
              class="pr-4 pl-4 pt-3 pb-2"
              v-for="(reminder,
              index) in grantApplication.Grant_Application_Reminders"
              :key="reminder.Grant_Application_Reminder_Id"
              v-bind:class="
                grantApplication.Grant.Application_Deadline != '0000-00-00'
                  ? { 'light-background': index % 2 === 0 }
                  : { 'light-background': index % 2 === 1 }
              "
            >
              <i
                v-on:click="
                  removeReminder(reminder.Grant_Application_Reminder_Id)
                "
                class="material-icons ml-2 pointer float-right"
              >
                delete
              </i>
              <h5 class="float-right">
                {{ $displayDate(reminder.Date) }}
              </h5>
              <h5>{{ reminder.Description }}</h5>
            </div>
            <h5
              class="pl-4 pr-4 pt-1"
              v-if="
                grantApplication.Grant_Application_Reminders.length == 0 &&
                  grantApplication.Grant.Application_Deadline == '0000-00-00'
              "
            >
              You have no upcoming dates for this grant.
            </h5>
          </div>
        </div>
      </div>
    </div>
    <GrantAppReminderModal
      v-bind:GrantApplicationId="grantApplicationIdForReminder"
      @createdGrantReminder="createdGrantReminder"
      IdString="Calendar"
    />
    <GrantAppReminderDetailsModal
      v-bind:GrantApplicationReminder="selectedEvent"
    />
  </div>
</template>

<script>
import $ from "jquery";
import GrantAppReminderModal from "@/modals/GrantAppReminderModal.vue";
import GrantAppReminderDetailsModal from "@/modals/GrantAppReminderDetailsModal.vue";
import VueCal from "vue-cal";
import "vue-cal/dist/vuecal.css";

export default {
  name: "Calendar",
  components: {
    GrantAppReminderModal,
    GrantAppReminderDetailsModal,
    VueCal
  },
  data() {
    return {
      grantApplications: [],
      grantApplicationIdForReminder: "-1",
      events: [],
      selectedEvent: null,
      modalIdString: "Calendar"
    };
  },
  created() {
    this.$store.commit("updateLoading", true);
  },
  async mounted() {
    await this.getMyGrants();
  },
  methods: {
    orderGrantApplicationsByDate(a, b) {
      if (a.Grant.Application_Deadline < b.Application_Deadline) {
        return -1;
      } else if (a.Application_Deadline > b.Application_Deadline) {
        return 1;
      }
      return 0;
    },
    orderRemindersByDate(a, b) {
      if (a.Date < b.Date) {
        return -1;
      } else if (a.Date > b.Date) {
        return 1;
      }
      return 0;
    },
    setReminderDate(applicationId) {
      this.grantApplicationIdForReminder = applicationId;
      $("#grantAppReminderModalCalendar").modal("show");
    },
    async createdGrantReminder() {
      await this.getMyGrants();
    },
    async getMyGrants() {
      var view = this;
      view.$store.commit("updateLoading", true);
      try {
        var res = await view.$store.getters.fetcher({
          query:
            `{
            grantApplicationsForUser(userId:` +
            view.$store.getters.user.User_Id +
            `) {
              Grant_Application_Id
              Grant {
                Grant_Id
                Title
                Application_Deadline
                URL
              }
              Grant_Application_Status {
                Grant_Application_Status_Id
              }
              Grant_Application_Reminders {
                Grant_Application_Reminder_Id
                Description
                Date
              }
            }
          }`
        });
        view.grantApplications = res.data.grantApplicationsForUser.sort(
          view.orderGrantApplicationsByDate
        );
        view.events.length = 0;
        var events = [];
        view.grantApplications.forEach(app => {
          app.Grant_Application_Reminders = app.Grant_Application_Reminders.sort(
            view.orderRemindersByDate
          );
          events = events.concat(view.addApplicationEvents(app));
        });
        view.events = view.events.concat(events);
      } catch (error) {
        console.log(error);
        view.$store.commit("updateLoading", false);
      }
      view.$store.commit("updateLoading", false);
    },
    addApplicationEvents(grantApplication) {
      var events = [];
      if (grantApplication.Grant.Application_Deadline != "0000-00-00") {
        events.push({
          start: grantApplication.Grant.Application_Deadline,
          end: grantApplication.Grant.Application_Deadline,
          title: "Application Due",
          content: '<i class="v-icon material-icons">shopping_cart</i>',
          class: "leisure",
          grantApplication: grantApplication,
          grantReminder: {
            Description: "Application Due",
            Date: grantApplication.Grant.Application_Deadline
          }
        });
      }
      grantApplication.Grant_Application_Reminders.forEach(reminder => {
        events.push({
          start: reminder.Date,
          end: reminder.Date,
          title: reminder.Description,
          content: '<i class="v-icon material-icons">shopping_cart</i>',
          class: "leisure",
          grantApplication: grantApplication,
          grantReminder: reminder
        });
      });
      return events;
    },
    eventClick(event, e) {
      this.selectedEvent = event;
      $("#grantAppReminderDetailsModal").modal("show");
      e.stopPropagation();
    },
    async removeReminder(grantApplicationReminderId) {
      var view = this;
      view.$store.commit("updateLoading", true);
      try {
        await view.$store.getters.fetcher({
          query: `mutation($grantApplicationReminderId: Int!){
              RemoveGrantApplicationReminder(grantApplicationReminderId: $grantApplicationReminderId)
            }`,
          variables: {
            grantApplicationReminderId: parseInt(grantApplicationReminderId)
          }
        });
        await view.getMyGrants();
      } catch (e) {
        console.log(e);
        view.$store.commit("updateLoading", false);
      }
      view.$store.commit("updateLoading", false);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.light-background {
  background-color: #eeeeee;
}
</style>
